module.exports = __webpack_public_path__ + "img/Percentage Icon - charcoal.6460fe66.svg";